import { render, staticRenderFns } from "./riskAssessmentCategoryTable.vue?vue&type=template&id=597fe6bf"
import script from "./riskAssessmentCategoryTable.vue?vue&type=script&lang=js"
export * from "./riskAssessmentCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports